(() => {
  const sections = () => location.pathname === Shopify.routes.cart
    ? ['cart-drawer', 'cart-desktop', 'cart-mobile']
    : ['cart-drawer'];

  async function refreshCart() {
    const names = sections();
    const [cart, html] = await Promise.all([
      fetch(`${Shopify.routes.cart}.js`).then(response => response.json()),
      fetch(`${Shopify.routes.cart}?sections=${names.join(',')}`).then(response => response.json())
    ]);
    window.Cart?.fillBasket(cart.items);
    window.Cart?.updateTotals(cart.item_count);
    window.Cart?.updateAllHtml(html);
  }

  async function updateLines(updates) {
    await fetch(`${Shopify.routes.cart_update}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  class FreeGiftSelector extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-variant-id]').forEach(button => {
        button.addEventListener('click', () => this.selectGift(button));
      });
      this.initSwiper();
      this.reconcile();
    }

    initSwiper() {
      const slider = this.querySelector('.free-gift__option_slider');
      if (!slider || slider.swiper || typeof Swiper === 'undefined') return;

      const slides = Array.from(slider.querySelectorAll('.swiper-slide'));
      const selectedSlide = slider.querySelector('[aria-pressed="true"]')?.closest('.swiper-slide');
      const selectedIndex = Math.max(0, slides.indexOf(selectedSlide));

      new Swiper(slider, {
        slidesPerView: 1.6,
        spaceBetween: 10,
        centeredSlides: false,
        loop: false,
        grabCursor: false,
        initialSlide: selectedIndex,
      });
    }

    


    async selectGift(button) {
      if (FreeGiftSelector.busy || button.getAttribute('aria-pressed') === 'true') return;
      FreeGiftSelector.busy = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const cart = await fetch(`${Shopify.routes.cart}.js`).then(response => response.json());
        const giftUpdates = {};
        cart.items.forEach(item => {
          if (item.properties?._free_gift === 'true') giftUpdates[item.key] = 0;
        });
        if (Object.keys(giftUpdates).length) await updateLines(giftUpdates);

        await fetch(`${Shopify.routes.cart_add}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(button.dataset.variantId), quantity: 1, properties: { _free_gift: 'true' } }]
          })
        });
        await refreshCart();
      } finally {
        FreeGiftSelector.busy = false;
        button.removeAttribute('aria-busy');
      }
    }

    async reconcile() {
      if (FreeGiftSelector.busy) return;
      FreeGiftSelector.busy = true;
      try {
        const cart = await fetch(`${Shopify.routes.cart}.js`).then(response => response.json());
        const gifts = cart.items.filter(item => item.properties?._free_gift === 'true');
        const qualifyingTotal = cart.items.reduce((total, item) =>
          item.properties?._free_gift === 'true' ? total : total + item.final_line_price, 0);
        const allowedIds = this.dataset.giftIds.split(',').map(Number);
        const updates = {};
        gifts.forEach((item, index) => {
          const remove = qualifyingTotal < Number(this.dataset.threshold) ||
            !allowedIds.includes(item.variant_id) || index > 0;
          if (remove) updates[item.key] = 0;
          else if (item.quantity !== 1) updates[item.key] = 1;
        });

        if (!Object.keys(updates).length) return;
        await updateLines(updates);
        await refreshCart();
      } finally {
        FreeGiftSelector.busy = false;
      }
    }
  }

  customElements.define('free-gift-selector', FreeGiftSelector);
})();

function initFreeGiftSwiper() {
  document.querySelectorAll('free-gift-selector').forEach(selector => {
    selector.initSwiper();
  });
}
